import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  makeStyles
} from '@material-ui/core';
import Page from 'src/components/Page';
import Toolbar from './Toolbar';
import Firebase from 'src/Firebase.js'
import BarleyOutTableWrapper from './BarleyOutTableWrapper';


const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));


const BarleyOutListView = () => {
  const classes = useStyles();


  useEffect(() => {
    // Update the document title using the browser API

    
  });


  return (
    <Page
      className={classes.root}
      id="barleyOut"
      title="Barley Request"
    >
      <Container maxWidth={false}>
        <Toolbar />
        <Box mt={3}>
         <div id='fk121'>
          <BarleyOutTableWrapper />
          </div>
          

        </Box>
      </Container>
    </Page>
  );
};

export default BarleyOutListView;
